import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import { get_driver_list } from "../../redux/driverSlice";
import {
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DisplayData from "../../components/DisplayData";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";

const DriverList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState(5);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const { driver_list, total_driver_count } = useSelector(
    (state) => state.drivers
  );

  useEffect(() => {
    store.dispatch(get_driver_list({ page: page, rows: rows }));
  }, []);
  const onPrevious = () => {
    initialValue == 1 || setInitialValue(Number(initialValue) - Number(rows));
    page == 1 || setpage(page - 1);
    page === 1 ||
      store.dispatch(get_driver_list({ page: page - 1, rows: rows }));
  };

  const onNext = () => {
    rows * page >= total_driver_count ||
      setInitialValue(Number(initialValue) + Number(rows));
    rows * page >= total_driver_count || setpage(page + 1);
    rows * page >= total_driver_count ||
      store.dispatch(get_driver_list({ page: page + 1, rows: rows }));
  };
  return (
    <>
     <Card
  bg="#fff"
  paddingInline={5}
  paddingBlock={2}
  flexDirection={["column", "row"]}
  alignItems={["flex-start", "center"]}
  gap={3}
  flexWrap="wrap"
>
<Flex
    justifyContent="space-between"
    alignItems="center"
    w="100%"
    flexWrap="wrap"
  >
    <Heading fontSize="xl">Drivers List</Heading>
    <button
      style={{
        backgroundColor: "#007bc9",
        color: "white",
        padding: "8px 16px",
        borderRadius: "5px",
        fontWeight: "bold",
        cursor: "pointer",
      }}
      onClick={() => navigate("/driver-list/add-driver")}
    >
      + Add Driver
    </button>
  </Flex>


  <Spacer display={["none", "block"]} /> {/* Spacer only for larger screens */}

  <Flex alignItems="center" gap={2} w={["100%", "auto"]}>
    <Select
      placeholder=""
      size="md"
      value={rows}
      onChange={(e) => {
        store.dispatch(get_driver_list({ page: page, rows: e.target.value }));
        setRows(e.target.value);
      }}
      w={["100%", "80px"]}  // Full width on mobile, compact on desktop
    >
      <option value="5">5</option>
      <option value="10">10</option>
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </Select>
  </Flex>

  <InputGroup
    bg="#f4f5f7"
    borderRadius={5}
    maxW="sm"
    w={["100%", "auto"]}
  >
    <Input placeholder="Search..." />
    <InputRightElement>
      <FiSearch />
    </InputRightElement>
  </InputGroup>
</Card>

      <SimpleGrid minChildWidth="xs" spacing="10px">
        {driver_list.map((el, i) => (
          <Card
            paddingInline={5}
            paddingBlock={2}
            cursor={"pointer"}
            onClick={() =>
              navigate("/driver-list/driver-detail", { state: el.id })
            }
          >
            <Flex justify={"space-between"}>
              <DisplayData
                fs={"16px"}
                v_color={"#007bc9"}
                fw={"bold"}
                value={el.name}
              />
              <DisplayData
                // fs={"16px"}
                v_color={"#f37022"}
                fw={"bold"}
                value={el.uuid}
              />
            </Flex>
            <DisplayData title={"Mobile"} value={el.mobile1 || "NA"} />
            <DisplayData title={"Email"} value={el.email || "NA"} />
            <DisplayData title={"Aadhar"} value={el.aadhaar || "NA"} />
            <DisplayData title={"Pan"} value={el.pan || "NA"} />
            <DisplayData
              title={"Status"}
              v_color={"#000"}
              value={"Not Verified" || "NA"}
            />
          </Card>
        ))}
      </SimpleGrid>
      <Card
        alignItems={"center"}
        alignSelf={"end"}
        gap={3}
        flexDirection={"row"}
      >
        <FiChevronLeft
          cursor={"pointer"}
          color={page == 1 ? "gray" : "#007bc9"}
          size={35}
          onClick={onPrevious}
        />
        <Flex gap={3}>
          <Text>{initialValue}</Text>-
          <Text>
            {rows * page >= total_driver_count
              ? total_driver_count
              : rows * page}
          </Text>
          <Text>of</Text>
          <Text>{total_driver_count}</Text>
        </Flex>
        <FiChevronRight
          cursor={"pointer"}
          color={rows * page >= total_driver_count ? "gray" : "#007bc9"}
          size={35}
          onClick={onNext}
        />
      </Card>
    </>
  );
};

export default DriverList;
